import { combineReducers } from 'redux';

import { userReducer } from './user/user.reducer';
import { categoriesReducer } from './categories/category.reducer';
import { environmentReducer } from './environments/environment.reducer';

export const rootReducer = combineReducers({
  user: userReducer,
  categories: categoriesReducer,
  environment: environmentReducer,
});
